import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export type ScopedAccessSessionState = {
    isConfirmedScopedAccessActive: boolean
}

const initialState: ScopedAccessSessionState = {
    isConfirmedScopedAccessActive: false,
}

const scopedAccessSessionSlice = createSlice({
    name: 'scopedAccessSession',
    initialState,
    reducers: {
        setIsConfirmedScopedAccessActive: (state, action: PayloadAction<boolean>) => {
            state.isConfirmedScopedAccessActive = action.payload
        },
    },
})

export const { setIsConfirmedScopedAccessActive } = scopedAccessSessionSlice.actions

export const selectIsConfirmedScopedAccessActive = (state: {
    scopedAccessSession: ScopedAccessSessionState
}): boolean => state.scopedAccessSession.isConfirmedScopedAccessActive

export default scopedAccessSessionSlice.reducer
